import { Routes, Route } from 'react-router-dom';
import PrivacyPolicy from 'routes/PrivacyPolicy';
import TermsOfService from 'routes/ToS';
import Home from './routes/home';
import Plaid from './routes/plaid';
import IdentityVerification from './routes/IdentityVerification';
import TransferReceipt from './routes/transferReceipt';
import ContactShare from './routes/contactShare';
import ContactShareRequest from './routes/contactShareRequest';
import Version from './routes/Version';
import MicroDeposit from './routes/MicroDeposit';
import PlaidUpdate from './routes/update';

const App = () => (
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="plaid/update" element={<PlaidUpdate />} />
    <Route path="plaid/micro-deposit" element={<MicroDeposit />} />
    <Route path="plaid" element={<Plaid />} />
    <Route path="idv" element={<IdentityVerification />} />
    <Route path="/tos" element={<TermsOfService />} />
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/transfers/receipt" element={<TransferReceipt />} />
    <Route path="/contact/share" element={<ContactShare />} />
    <Route path="/contact/share_request" element={<ContactShareRequest />} />
    <Route path="/version" element={<Version />} />
  </Routes>
);

export default App;
